import React from 'react'
import './cardsContainer.css'
import logger from '../../../utils/logger'

export const CardsContainer = ({ CardComponent, data }) => {

  logger.debug('CardsContainer DATA: ', data)
  return (

    <div className='cards-container'>
      {data.items && data.items.length > 0 ?

        data.items.map((i) => {

          return (
            
            <CardComponent key={i.id} {...i}/>
          )
        })
        : null}
    </div>
  )
}
